import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 16px 0px;
  justify-content: flex-start;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
  }
`;

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
`;
